// extracted by mini-css-extract-plugin
module.exports = {"img":"InboxTask_img__2wkh_"};